import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setMenuCollapsed } from '../redux/actions/generalActions';
import { setSubMenuCollapsed } from '../redux/actions/generalActions';
import { Layout, Menu, Affix } from 'antd';
import { DesktopOutlined, MailOutlined } from '@ant-design/icons';
import logo from './../assets/logonew.svg';
import logoCondensed from './../assets/logoCondensed.png';
import {
  DealsIcon,
  DealsImgicon,
  FileIcon,
  StarIcon,
  UsersIcon,
} from '../assets/icons/icons';
const { Sider } = Layout;
const _ = require('lodash');

function SiderComponent({ props }) {
  const userDetails = useSelector((state) => state.general.userDetails);
  const userRole = userDetails?.role;
  const isSuperAdmin = userRole === 'superAdmin';
  const isAdmin = userRole === 'admin';
  const isDealAdmin = userRole === 'dealAdmin';
  const isSubAdmin = userRole === 'subAdmin';
  const golfClubDetails = useSelector(
    (state) => state.golfClub.golfClubDetails,
  );
  const subMenuCollapsed = useSelector(
    (state) => state.general.subMenuCollapsed,
  );
  const numberGreenfeeabkommenDeals = golfClubDetails.membershipDeals.length;
  const numberTopDeals = golfClubDetails.topDeals
    ? golfClubDetails.topDeals.length
    : 0;
  const numberEduDeals = _.countBy(golfClubDetails.deals, function (e) {
    return e.dealDetails.type === 'edu';
  });
  const numberMemberDeals = _.countBy(golfClubDetails.deals, function (e) {
    return e.name === 'Member Guest' && e.dealDetails.type === 'special';
  });
  const numberDiscountcardDeals = _.countBy(
    golfClubDetails.deals,
    function (e) {
      return e.dealDetails.type === 'discountCard';
    },
  );
  const numberSurchargeDeals = _.countBy(golfClubDetails.deals, function (e) {
    return e.dealDetails.type === 'surcharge';
  });
  const numberAllianceDeals = _.countBy(golfClubDetails.deals, function (e) {
    return e.dealDetails.type === 'alliance';
  });
  const numberEarlyBirdDeals = _.countBy(golfClubDetails.deals, function (e) {
    return (
      (e.name === 'Early Bird' || e.name === 'Sundowner') &&
      e.dealDetails.type === 'special'
    );
  });
  const numberSpecialDeals = _.countBy(golfClubDetails.deals, function (e) {
    return (
      e.name !== 'Early Bird' &&
      e.name !== 'Sundowner' &&
      e.name !== 'Member Guest' &&
      e.name !== 'Member Deal' &&
      e.dealDetails.type === 'special'
    );
  });

  console.log('numberSpecialDeals', numberSpecialDeals);
  const handleLogout = async () => {
    try {
      await greenfeeDealsApi.get('/logout'); // calls backend logout
    } catch (error) {
      console.log('Logout error:', error);
    }

    // Clear localStorage
    localStorage.removeItem('sessionBnd');

    // Redirect to login page
    window.location.href = '/';
  };
  const { SubMenu } = Menu;
  const dispatch = useDispatch();
  const menuCollapsed = useSelector((state) => state.general.menuCollapsed);
  const toggleCollapsed = () => {
    const collapsed = !menuCollapsed;
    dispatch(setMenuCollapsed(collapsed));
  };
  const toggleSubCollapsed = (openKeys) => {
    dispatch(setSubMenuCollapsed(openKeys));
  };
  const Showlogo = () => {
    if (!menuCollapsed) {
      return <img src={logo} alt="Logo" width={'100%'} />;
    } else {
      return <img src={logoCondensed} alt="Logo" width={30} />;
    }
  };
  return (
    <div
      style={{
        backgroundColor: '#1B392F',
        minHeight: '100%',
      }}
    >
      <Affix offsetTop={0}>
        <Sider
          style={{
            backgroundColor: '#1B392F',
            minHeight: '100vh',
          }}
          collapsible
          collapsed={menuCollapsed}
          onCollapse={toggleCollapsed}
          trigger={null}
          width={255}
        >
          <div
            style={{
              // minHeight: 100,
              justifyContent: 'flex-start',
              alignItems: 'center',
              display: 'flex',
              padding: 25,
              borderBottom: '1px solid #ffffff10',
            }}
          >
            <Showlogo />
          </div>

          <Menu
            defaultSelectedKeys={['1']}
            mode="inline"
            theme="dark"
            style={{ backgroundColor: '#1B392F', padding: '25px 0px 25px 0px' }}
            selectedKeys={location.pathname}
            activeKey={location.pathname}
            openKeys={subMenuCollapsed}
            onOpenChange={toggleSubCollapsed}
            inlineIndent={20}
            className="custom-sub-menuitem"
          >
            <Menu.Item key="/details" className="sidebar-menuitem">
              <FileIcon />
              <span>Stammdaten</span>
              <Link to="/details" />
            </Menu.Item>
            {(isSuperAdmin || isAdmin) && (
              <Menu.Item key="/admin/users" className="sidebar-menuitem">
                <UsersIcon />
                <span>Users</span>
                <Link to="/users" />
              </Menu.Item>
            )}

            {(isSuperAdmin || isAdmin) && (
              <Menu.Item
                key="/deals/topdealsimages"
                className="sidebar-menuitem"
              >
                <DealsImgicon />
                <span>Deals Images</span>
                <Link to="/deals/topdealsimages" />
              </Menu.Item>
            )}
            {(isSuperAdmin || isAdmin) && (
              <Menu.Item key="/admin/packages" className="sidebar-menuitem">
                <DesktopOutlined />
                <span>Pakete verwalten</span>
                <Link to="/admin/packages" />
              </Menu.Item>
            )}
            <Menu.Item key="/deals/topdeals" className="sidebar-menuitem">
              <StarIcon />
              <span>Top Deals ({numberTopDeals > 0 ? numberTopDeals : 0})</span>
              <Link to="/deals/topdeals" />
            </Menu.Item>
            {/* <Menu.Item key="/deals/alldeals" className="sidebar-menuitem">
              <DealsIcon />
              {/* <span>Deals ({numberTopDeals > 0 ? numberTopDeals : 0})</span> */}
            {/* <span>Deals</span>
              <Link to="/deals/alldeals" />
            </Menu.Item> */}

            <SubMenu
              key="sub1"
              className="sidebar-menuitem"
              title={
                <>
                  <DealsIcon />
                  <span>Deals</span>
                </>
              }
            >
              <Menu theme="dark" style={{ backgroundColor: '#1B392F' }}>
                <Menu.Item key="/deals/edu" className="sidebar-menuitem">
                  <DesktopOutlined />
                  <span>
                    Studenten & Jugend (
                    {numberEduDeals.true > 0 ? numberEduDeals.true : 0})
                  </span>
                  <Link to="/deals/edu" />
                </Menu.Item>
                {
                  <Menu.Item
                    key="/deals/earlybird"
                    className="sidebar-menuitem"
                  >
                    <DesktopOutlined />
                    <span>
                      Early Bird & Sundowner (
                      {numberEarlyBirdDeals.true > 0
                        ? numberEarlyBirdDeals.true
                        : 0}
                      )
                    </span>
                    <Link to="/deals/earlybird" />
                  </Menu.Item>
                }
                <Menu.Item
                  key="/deals/greenfeeabkommen"
                  className="sidebar-menuitem"
                >
                  <DesktopOutlined />
                  <span>Greenfeeabkommen ({numberGreenfeeabkommenDeals})</span>
                  <Link to="/deals/greenfeeabkommen" />
                </Menu.Item>
                <Menu.Item key="/deals/greenfeecards">
                  <DesktopOutlined />
                  <span>
                    Rabattkarten (
                    {numberDiscountcardDeals.true > 0
                      ? numberDiscountcardDeals.true
                      : 0}
                    )
                  </span>
                  <Link to="/deals/greenfeecards" />
                </Menu.Item>

                <Menu.Item
                  key="/deals/clubverbuende"
                  className="sidebar-menuitem"
                >
                  <DesktopOutlined />
                  <span>
                    Clubverbünde (
                    {numberAllianceDeals.true > 0
                      ? numberAllianceDeals.true
                      : 0}
                    )
                  </span>
                  <Link to="/deals/clubverbuende" />
                </Menu.Item>

                <Menu.Item key="/deals/sonstige" className="sidebar-menuitem">
                  <DesktopOutlined />
                  <span>
                    Specials (
                    {numberSpecialDeals.true > 0 ? numberSpecialDeals.true : 0})
                  </span>
                  <Link to="/deals/sonstige" />
                </Menu.Item>
                <Menu.Item key="/deals/memberdeal">
                  <DesktopOutlined />
                  <span>
                    Member Guest (
                    {numberMemberDeals.true > 0 ? numberMemberDeals.true : 0})
                  </span>
                  <Link to="/deals/memberdeal" />
                </Menu.Item>
                <Menu.Item key="/deals/aufschlaege">
                  <DesktopOutlined />
                  <span>
                    VcG & Fernmitglied (
                    {numberSurchargeDeals.true > 0
                      ? numberSurchargeDeals.true
                      : 0}
                    )
                  </span>
                  <Link to="/deals/aufschlaege" />
                </Menu.Item>
              </Menu>
            </SubMenu>

            <Menu.Item onClick={handleLogout} className="sidebar-menuitem">
              <UsersIcon />
              <span>Logout</span>
            </Menu.Item>
          </Menu>
        </Sider>
      </Affix>
    </div>
  );
}

export default SiderComponent;
